"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreTown = exports.StoreForSitemap = exports.StoreModel = exports.ServicesNotAvailable = exports.LocalizedString = exports.OpenCloseTimePair = void 0;
const model_validation_1 = require("@grandvision/model-validation");
const util_1 = require("./util");
const { Expose, Transform } = model_validation_1.Transformer;
const { toInt, makeNestedModelArray } = model_validation_1.TransformerExt;
const { IsInt, IsNumber, IsString, IsBoolean, IsArray, IsEnum, ValidateIf } = model_validation_1.Validator;
const { isNotNull, isNotUndefined } = model_validation_1.ValidatorExt;
class OpenCloseTimePair {
}
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], OpenCloseTimePair.prototype, "open", void 0);
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], OpenCloseTimePair.prototype, "close", void 0);
exports.OpenCloseTimePair = OpenCloseTimePair;
const fromOpenClosePairIfUndefined = (day, openOrClose) => {
    return ({ value, obj }) => {
        if (value !== undefined) {
            return value;
        }
        return util_1.getObjectPath(obj, `${day}OpenClose.0.${openOrClose}`, false) || null;
    };
};
class LocalizedString {
}
__decorate([
    Expose(),
    IsString(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", String)
], LocalizedString.prototype, "nl-NL", void 0);
__decorate([
    Expose(),
    IsString(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", String)
], LocalizedString.prototype, "nl-BE", void 0);
__decorate([
    Expose(),
    IsString(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", String)
], LocalizedString.prototype, "fr-BE", void 0);
exports.LocalizedString = LocalizedString;
var ServicesNotAvailable;
(function (ServicesNotAvailable) {
    ServicesNotAvailable["APPOINTMENTS"] = "APPOINTMENTS";
    ServicesNotAvailable["PICK_UP_IN_STORE"] = "PICK_UP_IN_STORE";
    ServicesNotAvailable["OPTOMETRY"] = "OPTOMETRY";
    ServicesNotAvailable["EVENING_APPOINTMENTS"] = "EVENING_APPOINTMENTS";
})(ServicesNotAvailable = exports.ServicesNotAvailable || (exports.ServicesNotAvailable = {}));
class StoreModel {
    constructor() {
        this.mondayOpenClose = [];
        this.tuesdayOpenClose = [];
        this.wednesdayOpenClose = [];
        this.thursdayOpenClose = [];
        this.fridayOpenClose = [];
        this.saturdayOpenClose = [];
        this.sundayOpenClose = [];
        this.Monday_Open = null;
        this.Monday_Close = null;
        this.Tuesday_Open = null;
        this.Tuesday_Close = null;
        this.Wednesday_Open = null;
        this.Wednesday_Close = null;
        this.Thursday_Open = null;
        this.Thursday_Close = null;
        this.Friday_Open = null;
        this.Friday_Close = null;
        this.Saturday_Open = null;
        this.Saturday_Close = null;
        this.Sunday_Open = null;
        this.Sunday_Close = null;
        this.lat = null;
        this.lon = null;
    }
}
__decorate([
    Transform(toInt),
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], StoreModel.prototype, "code", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "storeName", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreModel.prototype, "storeNameLocalized", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "streetName", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreModel.prototype, "streetNameLocalized", void 0);
__decorate([
    Expose(),
    IsString(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", String)
], StoreModel.prototype, "streetNumber", void 0);
__decorate([
    Expose(),
    IsString(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", String)
], StoreModel.prototype, "additionalStreetInfo", void 0);
__decorate([
    Expose(),
    IsString(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", String)
], StoreModel.prototype, "postalCode", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "town", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreModel.prototype, "townLocalized", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "country", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "Phone1", void 0);
__decorate([
    Expose(),
    IsString(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", String)
], StoreModel.prototype, "storeEmailAddress", void 0);
__decorate([
    Expose(),
    Transform(makeNestedModelArray(OpenCloseTimePair), { toClassOnly: true }),
    __metadata("design:type", Array)
], StoreModel.prototype, "mondayOpenClose", void 0);
__decorate([
    Expose(),
    Transform(makeNestedModelArray(OpenCloseTimePair), { toClassOnly: true }),
    __metadata("design:type", Array)
], StoreModel.prototype, "tuesdayOpenClose", void 0);
__decorate([
    Expose(),
    Transform(makeNestedModelArray(OpenCloseTimePair), { toClassOnly: true }),
    __metadata("design:type", Array)
], StoreModel.prototype, "wednesdayOpenClose", void 0);
__decorate([
    Expose(),
    Transform(makeNestedModelArray(OpenCloseTimePair), { toClassOnly: true }),
    __metadata("design:type", Array)
], StoreModel.prototype, "thursdayOpenClose", void 0);
__decorate([
    Expose(),
    Transform(makeNestedModelArray(OpenCloseTimePair), { toClassOnly: true }),
    __metadata("design:type", Array)
], StoreModel.prototype, "fridayOpenClose", void 0);
__decorate([
    Expose(),
    Transform(makeNestedModelArray(OpenCloseTimePair), { toClassOnly: true }),
    __metadata("design:type", Array)
], StoreModel.prototype, "saturdayOpenClose", void 0);
__decorate([
    Expose(),
    Transform(makeNestedModelArray(OpenCloseTimePair), { toClassOnly: true }),
    __metadata("design:type", Array)
], StoreModel.prototype, "sundayOpenClose", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("monday", "open"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Monday_Open", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("monday", "close"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Monday_Close", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("tuesday", "open"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Tuesday_Open", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("tuesday", "close"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Tuesday_Close", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("wednesday", "open"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Wednesday_Open", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("wednesday", "close"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Wednesday_Close", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("thursday", "open"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Thursday_Open", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("thursday", "close"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Thursday_Close", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("friday", "open"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Friday_Open", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("friday", "close"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Friday_Close", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("saturday", "open"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Saturday_Open", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("saturday", "close"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Saturday_Close", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("sunday", "open"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Sunday_Open", void 0);
__decorate([
    Expose({ until: 2 }),
    Transform(fromOpenClosePairIfUndefined("sunday", "close"), { toClassOnly: true }),
    ValidateIf(isNotNull),
    IsInt(),
    __metadata("design:type", Object)
], StoreModel.prototype, "Sunday_Close", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "timeZone", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsBoolean(),
    __metadata("design:type", Boolean)
], StoreModel.prototype, "enabled", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotNull),
    IsNumber(),
    __metadata("design:type", Object)
], StoreModel.prototype, "lat", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotNull),
    IsNumber(),
    __metadata("design:type", Object)
], StoreModel.prototype, "lon", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsBoolean(),
    __metadata("design:type", Boolean)
], StoreModel.prototype, "optometry", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "metaDescription", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreModel.prototype, "metaDescriptionLocalized", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "storenote", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreModel.prototype, "storenoteLocalized", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsBoolean(),
    __metadata("design:type", Boolean)
], StoreModel.prototype, "show_in_rotator", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsBoolean(),
    __metadata("design:type", Boolean)
], StoreModel.prototype, "appointment_after_6", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsBoolean(),
    __metadata("design:type", Boolean)
], StoreModel.prototype, "urban", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "storeDetailImage", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "ownerFirstName", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "ownerLastName", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "province", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreModel.prototype, "provinceLocalized", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], StoreModel.prototype, "storeFacilities", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "storeOwnerImage", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "storeDescription", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreModel.prototype, "storeDescriptionLocalized", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    IsString(),
    __metadata("design:type", String)
], StoreModel.prototype, "slug", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreModel.prototype, "slugLocalized", void 0);
__decorate([
    Expose(),
    IsArray(),
    IsEnum(ServicesNotAvailable, { each: true }),
    __metadata("design:type", Array)
], StoreModel.prototype, "servicesNotAvailable", void 0);
exports.StoreModel = StoreModel;
class StoreForSitemap {
}
__decorate([
    Expose(),
    IsString(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", String)
], StoreForSitemap.prototype, "slug", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreForSitemap.prototype, "slugLocalized", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], StoreForSitemap.prototype, "town", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreForSitemap.prototype, "townLocalized", void 0);
exports.StoreForSitemap = StoreForSitemap;
class StoreTown {
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], StoreTown.prototype, "town", void 0);
__decorate([
    Expose(),
    ValidateIf(isNotUndefined),
    __metadata("design:type", LocalizedString)
], StoreTown.prototype, "townLocalized", void 0);
exports.StoreTown = StoreTown;
//# sourceMappingURL=index.js.map